import React, { useState, useEffect } from 'react';
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom";
import "@reach/skip-nav/styles.css";
import { SkipNavLink, SkipNavContent } from "@reach/skip-nav";
import { Container, Row, Col, Image } from 'react-bootstrap';

import { baseRoute, language } from './data/lang';
import GA from './components/GoogleAnalytics';
import {EventTracker} from './components/GoogleAnalytics';
import './styles/home.page.scss';

import Navigation from './components/Navbar';
import Challenge from './pages/challenge.page';
import Context from './pages/context.page';
import Process from './pages/process.page';
import CriteriaPage from './pages/criteria.page';
import Team from './pages/team.page';
import FAQ from './pages/faq.page';
import TermsAndConditions from './pages/termsandconditions.page';
import Footer from './components/Footer';

import CTAJumbo from './components/CTAJumbo';
// import moctoLogo from './assets/MOCTO_logo.png'
// import edcLogo from './assets/EDC_logo.png'
// import thriveLogo from './assets/HPD_logo.png'

const availableLanguages = Object.keys(language);

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


export default function App() {
  const [lang, setLang] = useState('eng')

  const getLang = (page) => {
    return language[lang][page];
  }
  return (
    <HashRouter basename={baseRoute}>
      {GA.init() && <GA.RouteTracker />}
      <SkipNavLink />
      <ScrollToTop />
      <Navigation
        l={language[lang]}
        availableLanguages={availableLanguages}
        currentLang={lang}
        setLang={setLang} />
      <main>
        <div>
          <SkipNavContent />
          <Switch>
            <Route path={`/challenge`}>
              <Challenge l={getLang('challenge')} />
            </Route>
            <Route path="/context">
              <Context l={getLang('context')} />
            </Route>
            <Route path="/process">
              <Process l={getLang('process')} />
            </Route>
            <Route path="/criteria">
              <CriteriaPage l={getLang('criteria')} />
            </Route>
            <Route path="/team">
              <Team l={getLang('team')} />
            </Route>
            <Route path="/faq">
              <FAQ l={getLang('faq')} />
            </Route>
            <Route path="/terms-and-conditions">
              <TermsAndConditions l={getLang('termsAndConditions')} />
            </Route>
            <Redirect exact from="/" to="/challenge" />
          </Switch>
        </div>
        <CTAJumbo cta={language[lang].challenge.cta} ctaLink={language[lang].applyLink} buttonText={language[lang].challenge.ctaButtonText} />
        {(language[lang].team.judges.length > 0 || language[lang].team.partners.length > 0) && 
          <Container className="mt-4 text-center">
            {renderPartners(language[lang].team.judges.concat(language[lang].team.partners))}
          </Container>
        }
        {language[lang].alertBottom &&
        <Col>
            <Row className="bg-primary text-white py-3 text-center">
                <Col>
                    {language[lang].alertBottom} <a href={language[lang].alertBottomLink} className="text-white bold" style={{fontSize: '16px'}} onClick={() => EventTracker("alert", "clicked the bottom alert link")}>{language[lang].alertBottomLinkText}</a>
                </Col>
            </Row>
        </Col>
        }
      </main>
      <Footer />
    </HashRouter>
  );
}

function renderPartners(partners) {
  return (
    <Row className="p-2 pb-5 w-100 d-flex justify-content-center">
      {partners.map((partner, i) => (
        <Col xs={6} md={2} className="align-top mb-2">
          <Image fluid src={partner.photoSrc} alt={partner.photoAlt} />
        </Col>
      ))}
    </Row>
  )
}